import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "./static/styles/_common.scss";
import AppRouter from "./router/AppRouter";
import ReactGA from "react-ga";
import variables from "./constants/assets/variables";
import ThemeWrapper from "./ThemeWrapper";

function App() {
  useEffect(() => {
    ReactGA.initialize(variables.trackingId);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <ThemeWrapper>
      <div>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </div>
    </ThemeWrapper>
  );
}

export default App;
